// @flow

import ToastMessage from './ToastMessage'
import { withUi } from 'src/decorators'

export default withUi(ToastMessage)
